export default {
   benefits: {
      allBenefits: [],
      loading: false,
      data: [],
      pagination: {
         tokenPages: [],
         totalPages: 0,
         currentPage: 1,
      }
   }
}
